module.exports = __webpack_public_path__ + "static/media/white_halftone_mobile.7cc0dcbc.png";